<template src="./LeafletMap.html"></template>
<script lang="js">
import Vue from 'vue';
import {LControlZoom, LGeoJson, LMap} from 'vue2-leaflet';
import {latLngBounds} from "leaflet";
import {Mapstyles} from "./mapstyles";
import MapOverview from "../mapoverview/MapOverview";
import MapOtaChange from "../mapotachange/MapOtaChange";
import MapManualUpdate from "../mapmanualupdate/MapManualUpdate";
import ErrorType from "../../enums/error-types";
import axios from "axios";
export default Vue.extend({
  name: 'nmouc-leaflet-map',
  components: {
    LMap,
    LControlZoom,
    LGeoJson,
    MapOverview,
    MapOtaChange,
    MapManualUpdate
  },
  data() {
    return {
      visible: true,
      dragging: false,
      world: undefined,
      officialBoundaries: undefined,
      mapRegions: undefined,
      mapRegionsWithGeoData: undefined,
      worldStyle: Mapstyles.world,
      officialBoundariesStyle: Mapstyles.officialBoundaries,
      axiosInstanceForGeoJsons: undefined
    };
  },
  mounted() {
    this.axiosInstanceForGeoJsons = axios.create({
      headers: {
        Accept: 'application/json',
      },
    });
    this.$nextTick(function () {
      this.resizeMap();
      this.createPane();
      this.listenForFitBounds();
    });
    this.getWorld();
    window.addEventListener('resize', this.listenForFitBounds);
  },
  computed: {
    showWorld() {
      return this.world !== undefined &&
        (this.$store.state.error !== undefined || this.mapRegionsWithGeoData !== undefined);
    }
  },
  watch: {
    '$store.state.mapupdateInformation': function () {
      this.getGeoDataAndEnrichMapRegions()
    },
    '$store.state.overview.labelOtaRegionHovered': function () {
      this.redrawMap();
    },
    '$store.state.overview.labelUpToDateRegionHovered': function () {
      this.redrawMap();
    },
    '$store.state.overview.labelOutdatedRegionHovered': function () {
      this.redrawMap();
    },
    '$store.state.error': function () {
      this.fitBoundsOfWorldIfError();
    }
  },
  methods: {
    getGeoDataAndEnrichMapRegions() {
      this.getGeoData();
    },
    getWorld() {
      if (process.env.VUE_APP_IS_LOCAL === false && this.$publicPath === "") {
        this.$store.commit('setError', ErrorType.RETRY_LATER_UI)
        this.$store.commit('setErrorDescription', 'publicPath not set')
        return
      }
      this.axiosInstanceForGeoJsons.get(`${this.$publicPath}officialboundaries/world.geo.json`,
          {
            validateStatus: () => true,
          })
          .then((response) => {
            this.world = response.data;
          })
          .catch((error) => {
            console.error('error', error);
            this.$store.commit('setError', ErrorType.RETRY_LATER_UI)
            this.$store.commit('setErrorDescription', 'request world: ' + error.message)
          })
    },
    getGeoData() {
      setTimeout(() => this.resizeMap(), 500);
      if (process.env.VUE_APP_IS_LOCAL === false && this.$publicPath === "") {
        this.$store.commit('setError', ErrorType.RETRY_LATER_UI)
        this.$store.commit('setErrorDescription', 'publicPath not set')
        return
      }
      if (this.$store.state.mapupdateInformation === undefined) {
        return;
      }
      if (this.officialBoundaries && this.mapRegions) {
        this.calculateMapRegionsEnrichedWithGeoData()
      } else {
        Promise.all([
          this.axiosInstanceForGeoJsons.get(`${this.$publicPath}officialboundaries/${this.$store.state.mapupdateInformation.productMarketName}-${this.$store.state.mapupdateInformation.ntg}.geo.json`,
              {
                validateStatus: () => true,
              }),
          this.axiosInstanceForGeoJsons.get(`${this.$publicPath}mapregions/${this.$store.state.mapupdateInformation.productMarketName}-${this.$store.state.mapupdateInformation.ntg}.geo.json`,
              {
                validateStatus: () => true,
              })
        ])
            .then(responses => {
              this.officialBoundaries = responses[0].data;
              this.mapRegions = responses[1].data;
              this.calculateMapRegionsEnrichedWithGeoData();
            })
            .catch(error => {
              console.error('error', error);
              this.$store.commit('setError', ErrorType.RETRY_LATER_UI);
              this.$store.commit('setErrorDescription', 'calculateMapRegionsEnrichedWithGeoData ' + error.message);
            });
      }
    },
    calculateMapRegionsEnrichedWithGeoData() {
      let mr = this.mapRegions;
      let m = this.$store.state.mapupdateInformation;
      let disabledRegIds =[];
      mr.features.forEach((value) => {
        // should be set, because otherwise change will not trigger onEachFeature function
        value.properties.newHovered = false;
        value.properties.oldHovered = false;

        const regId = value.properties.regId;
        const region = m.mapRegions.find((r) => r.regId === regId);
        if (region !== undefined) {
          value.properties.mapInfos = region;
        } else {
          value.properties.disabled = true
          disabledRegIds.push(regId);
        }
      });
      mr.features = mr.features.filter(r => !disabledRegIds.includes(r.properties.regId));
      this.officialBoundaries.features = this.officialBoundaries.features.filter(r =>  !disabledRegIds.includes(r.properties.regId));

      if (!this.mapRegionsWithGeoData) {
        this.fitBounds(mr);
      }
      this.mapRegionsWithGeoData = mr;
      this.listenForFitBounds();
    },
    listenForFitBounds() {
      if (this.$store.state.isVerySmallWindowWidth) {
        return;
      }
      this.resizeMap();
      this.fitBounds(this.mapRegionsWithGeoData)
      this.fitBoundsOfWorldIfError();
      this.fitBoundsOfWorldIfMapDisabled();
    },
    fitBounds(mr) {
      if (this.$store.getters.isMapDisabled) {
        this.fitBoundsOfWorldIfMapDisabled();
        return;
      }
      if (mr === undefined) {
        return;
      }
      let selectedOTARegion = mr.features.find((r) => r.properties.mapInfos && r.properties.mapInfos.selectedOTARegion);
      if (selectedOTARegion !== undefined) {
        this.fitBoundsToObject(selectedOTARegion.properties.bbox, 40)
      } else {
        this.fitBoundsToObject(mr.properties.bbox, 0)
      }
    },
    fitBoundsToObject(bbox, spaceTopAndBottom) {
      if (this.$store.state.isSmallWindowWidth) {
        this.fitBoundsToObjectMobile(bbox, spaceTopAndBottom)
      } else {
        this.fitBoundsToObjectDesktop(bbox, spaceTopAndBottom)
      }
    },
    fitBoundsToObjectDesktop(bbox, spaceTopAndBottom) {
      //redraw, avoid flickering
      //this.fitBoundsOfWorld()

      const bounds = latLngBounds(bbox);
      let mapupCardWidth = this.$parent.$refs.mapupCard.offsetWidth;
      let mapupCardContainerMarginLeftAndRight = this.$parent.$refs.mapupCardContainer2.offsetLeft;

      this.$refs.map.fitBounds(bounds, {
        'paddingTopLeft': [mapupCardWidth + mapupCardContainerMarginLeftAndRight, spaceTopAndBottom],
        'paddingBottomRight': [mapupCardContainerMarginLeftAndRight, spaceTopAndBottom]
      });
    },
    fitBoundsToObjectMobile(bbox, spaceTopAndBottom) {
      //redraw, avoid flickering
      //this.fitBoundsOfWorld()

      const bounds = latLngBounds(bbox);

      this.$refs.map.fitBounds(bounds, {
        'paddingTopLeft': [0, spaceTopAndBottom],
        'paddingBottomRight': [0, spaceTopAndBottom]
      });
    },
    fitBoundsOfWorldIfError() {
      if (this.$store.state.error !== undefined) {
        this.fitBoundsOfWorld()
      }
    },
    fitBoundsOfWorldIfMapDisabled() {
      if (this.$store.getters.isMapDisabled) {
        this.fitBoundsOfWorld()
      }
    },
    fitBoundsOfWorld() {
      this.$refs.map.fitBounds([[-60, -180], [90, 180]])
    },
    resizeMap() {
      this.$refs.map.mapObject.invalidateSize();
    },
    createPane() {
      this.$refs.map.mapObject.createPane('mapRegionsPane');
      this.$refs.map.mapObject.createPane('otaPane');
      this.$refs.map.mapObject.createPane('officialBoundariesPane');
      this.$refs.map.mapObject.createPane('worldPane');
      //set order with zIndex explicit
      this.$refs.map.mapObject._panes.worldPane.style.zIndex = 401
      this.$refs.map.mapObject._panes.officialBoundariesPane.style.zIndex = 402
      this.$refs.map.mapObject._panes.mapRegionsPane.style.zIndex = 403
      this.$refs.map.mapObject._panes.otaPane.style.zIndex = 404
      this.$refs.map.mapObject.addEventListener('drag', this.dragStart);
      this.$refs.map.mapObject.addEventListener('dragend', this.drop);
    },

    redrawMap() {
      this.mapRegionsWithGeoData = JSON.parse(JSON.stringify(this.mapRegionsWithGeoData));
      this.resizeMap();
    },

    dragStart() {
      this.dragging = true;
    },
    drop() {
      this.dragging = false;
    }
  }
});
</script>
<style lang="scss" src="./LeafletMap.scss"></style>
